import _ from 'lodash';

import cmsManageConfigurableLinkTemplate from './manage-configurable-link.html';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { fetchConfigurableLink, updateConfigurableLink } from 'app/actions/manage-configurable-link.actions';

const mapStateToThis = ({ manageConfigurableLink, session, config, ui, dictionary }) => {
  const { isLoading, entries } = manageConfigurableLink;
  const { locale } = session;
  const { locales, urlPattern, urlPatternError } = config;
  const { selectedLanguage } = ui;
  const terms = dictionary.terms[locale];

  return {
    isLoading,
    entries,
    locale,
    locales,
    urlPattern,
    urlPatternError,
    selectedLanguage,
    terms,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  fetchConfigurableLink,
  updateConfigurableLink,
};

@Inject('$ngRedux', 'Notifications', 'gettextCatalog')
class CmsManageConfigurableLinkController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = 'cmsConfigurableLinkWidget';
  }

  async $onInit() {
    await this.fetchConfigurableLink();
    this.initForm();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  initForm() {
    this.textMaxLength = 500;
    this.urlPattern = new RegExp(`^${this.urlPattern}$`);
    this.urlPatternError = this.urlPatternError.find((urlPatternError) => urlPatternError.code === this.locale);
    this.visibleOnSummary = this.entries && this.entries.length > 0 ? this.entries[0].visibleOnSummary : false;
    this.visibleOnInstants = this.entries && this.entries.length > 0 ? this.entries[0].visibleOnInstants : false;
    this.setEntries(this.locale);
  }

  setEntries(locale) {
    this.index = _.findIndex(this.entries, { locale });
    if (this.index === -1) {
      this.entries.push({
        locale,
      });
      this.index = this.entries.length - 1;
    }
  }

  async save(form) {
    form.$setSubmitted();

    if (this.entries.length !== this.locales.length) {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Please complete the form for all languages.'));
      return;
    }
    if (form.$valid && !this.fileErrors) {
      this.entries.forEach((entry) => {
        entry.visibleOnSummary = this.visibleOnSummary;
        entry.visibleOnInstants = this.visibleOnInstants;
      });

      await this.updateConfigurableLink(this.entries);
      this.Notifications.alertSuccess(this.gettextCatalog.getString('Configurable link saved successfully.'));
      this.setDirtyForm(this.DIRTY_FORM, false);
    }
  }

  async cancel() {
    await this.fetchConfigurableLink();
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been canceled.'));
  }
}

export class CmsManageConfigurableLinkComponent {
  constructor() {
    this.controller = CmsManageConfigurableLinkController;
    this.template = cmsManageConfigurableLinkTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/manage-configurable-link/manage-configurable-link-component.js